import { render, staticRenderFns } from "./BtnReabrir.vue?vue&type=template&id=d36cfe4a&"
import script from "./BtnReabrir.vue?vue&type=script&lang=js&"
export * from "./BtnReabrir.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports